<template>
  <v-app class="view">
    <v-dialog
        v-model="EditUserDialog"
        max-width="700"
        overlay-opacity="0.8"
        persistent
    >
      <form v-if="selectedUser" @submit.prevent="onSubmitUser" ref="userForm">
        <v-card class="pa-8">
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="selectedUser.username"
                    class="login-input"
                    label="Username"
                    outlined
                    placeholder=""
                    required
                    hide-details
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="selectedUser.password"
                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show_password ? 'text' : 'password'"
                    class="input-group--focused"
                    hint="At least 8 characters"
                    label="Password"
                    outlined
                    @click:append="show_password = !show_password"
                    hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                    v-model="selectedUser.name"
                    class="login-input"
                    label="ชื่อ สกุล"
                    outlined
                    placeholder=""
                    hide-details
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="selectedUser.nickname"
                    class="login-input"
                    label="ชื่อเล่น"
                    outlined
                    placeholder=""
                    required
                    hide-details
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                    v-model="selectedUser.department"
                    :items="[{text:'PJ',value:'PJ'},{text:'MT',value:'MT'},{text:'TT',value:'TT'},{text:'OL',value:'OL'},{text:'FT',value:'FT'},{text:'HM',value:'HM'},{text:'Account',value:'AC'},{text:'Marketing',value:'MK'},{text:'Admin',value:'AD'},{text:'Other',value:'OT'},{text:'Logistic',value:'LG'}]"
                    label="แผนก"
                    outlined
                    hide-details
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                    v-model="selectedUser.role"
                    :items="roles"
                    label="Role"
                    outlined
                    hide-details
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="selectedUser.employee_code"
                    class="login-input"
                    label="รหัสพนักงาน"
                    outlined
                    placeholder=""
                    hide-details
                    :rules="requiredIfSales"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>

              <v-col>
                <v-text-field
                    v-model="selectedUser.target_sale"
                    class="login-input"
                    label="เป้าการขาย"
                    outlined
                    placeholder=""
                    suffix="บาท"
                    hide-details
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="selectedUser.approving_credit"
                    class="login-input"
                    label="อนุมัติวงเงินไม่เกิน"
                    outlined
                    placeholder=""
                    hide-details
                    suffix="บาท"
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                    v-model="selectedUser.approving_invoices"
                    class="login-input"
                    label="อนุมัติค้างหนี้ไม่เกิน"
                    outlined
                    placeholder=""
                    hide-details
                    prefix=""
                    suffix="วัน"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                    v-model="selectedUser.parent_id"
                    :items="users.filter(user=>user.enabled).map(user=>{ return {
                      text: `[${roles_map[user.role]}] [${user.department}] ${user.nickname}`+ (user.approving_credit>0?` (วงเงิน ${user.approving_credit})`:''),
                      value:user.id,sort:user.role*1}})
                      .sort((a, b) => a.sort - b.sort)"
                    label="หัวหน้า"
                    outlined
                    hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-container>

          <v-btn class="close-button float-left" color="gray" fab tile @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn :loading="userLoading" class="close-button float-right" color="primary" fab tile type="submit">
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>

          <v-checkbox
              v-model="selectedUser.enabled"
              class="dialog-input  float-right mr-8"
              label="ใช้งาน"
              outlined
          >
          </v-checkbox>
          <div style="clear: both"></div>
        </v-card>
      </form>
    </v-dialog>


    <v-navigation-drawer
        :width="drawer_width"
        absolute
        class="nav fix-menu"
        permanent
        touchless
    >

      <v-card :class="{primary:activeMenu==='users'}" :to="'/admin'" class="pa-2" outlined tile>
        User
      </v-card>
      <v-card :class="{primary:activeMenu==='data'}" :to="'/data'" class="pa-2" outlined tile>
        Data
      </v-card>
      <v-card :class="{primary:activeMenu==='admin_setting'}" :to="'/admin_setting'" class="pa-2" outlined tile>
        Setting
      </v-card>

    </v-navigation-drawer>
    <v-content>
      <v-container
          :style="{
                        paddingLeft:(12+drawer_width)+'px',
                     }"
          child-flex
          class="container"

          fluid>
        <v-card>
          <v-card-title>
            จัดการผู้ใช้งาน
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                hide-details
                label="ค้นหา"
                single-line
            ></v-text-field>
          </v-card-title>
          <v-data-table
              v-if="users && Array.isArray(users)"
              :headers="[
                        { text: 'รูป', value: 'picture',},
                        { text: 'ชื่อ', value: 'nickname',},
                        { text: 'username', value: 'username' },
                        { text: 'รหัสพนักงาน', value: 'employee_code' },
                        { text: 'ชื่อจริง', value: 'name' },
                        { text: 'แผนก', value: 'department' },
                        { text: 'ตำแหน่ง', value: 'role' },

                      ]"
              :items="users"
              :loading="this.users.length===0"

              :search="search"
              class="elevation-1 mb-12 tr-clickable"
              @click:row="editUser"
          >
            <template v-slot:item.nickname="{ item }">
              <span :style="{'text-decoration':item.enabled?'':'line-through'}">
              {{ item.nickname }}
                </span>
            </template>
            <template v-slot:item.picture="{ item }">
              <v-avatar
                  color="grey"
                  size="32px"
                  :style="{'opacity':item.enabled?'1':'0.2'}"
              >
                <img
                    v-if="item.picture"
                    :src="item.picture"
                    alt="Avatar"
                >
                <v-icon v-else x-large>mdi-account-circle</v-icon>
              </v-avatar>
            </template>
            <template v-slot:item.role="{ item }">
              {{ UserConst.map(item.role) }}
            </template>

          </v-data-table>
          <v-btn absolute

                 bottom
                 class="close-button float-left"
                 color="primary"
                 fab
                 left @click="newUser">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>


      </v-container>
    </v-content>


  </v-app>
</template>
<style lang="scss" scoped>


.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 0px;
}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

</style>
<script lang="ts">

import {UserConst, User} from '@/models/User'
import {Component, Vue} from 'vue-property-decorator'
import {VForm} from 'vuetify/lib/components'
import LoadingDummy from '../components/LoadingDummy.vue'
import {DataArray} from '@/models/Response'
import Helper from '../services/Helper.js'
import { ref } from 'vue';

@Component({
  components: {LoadingDummy}
})
export default class ViewAdminUser extends Vue {

  UserConst = UserConst
  search = ''
  drawer_ratio = 0.15
  drawer_width = 200

  activeMenu = 'users'

  show_password = false

  users: User[] = []

  userLoading = false
  EditUserDialog = false
  selectedUser: User | null = null

  roles = [
    {text: 'Sale', value: UserConst.ROLE_USER},
    {text: 'Logistic', value: UserConst.ROLE_LOGISTIC},
    {text: 'Stock', value: UserConst.ROLE_STOCK},
    {text: 'Driver', value: UserConst.ROLE_DRIVER},
    {text: 'Driver External', value: UserConst.ROLE_EXTERNAL},
    {text: 'Account', value: UserConst.ROLE_ACCOUNT},
    {text: 'Marketing', value: UserConst.ROLE_MARKETING},
    {text: 'Manager', value: UserConst.ROLE_MANAGER},
    {text: 'Director', value: UserConst.ROLE_DIRECTOR},
    {text: 'CEO', value: UserConst.ROLE_CEO},
    {text: 'Admin', value: UserConst.ROLE_ADMIN}
  ]
  roles_map = {
    21: 'Stock',
    20: 'Sale',
    17: 'Logistic',
    18: 'Driver',
    19: 'Driver External',
    15: 'Account',
    10: 'Manager',
    5: 'Director',
    2: 'CEO',
    1: 'Admin'
  }
  // pagination = {
  //   ascending: true,
  //   sortBy: 'name',
  //   rowsPerPage: 5,
  //   page: 1,
  // }

  async editUser(user: User) {
    this.userLoading = true

    this.EditUserDialog = true

    if (user.id) {
      this.selectedUser = await (new User()).load<User>(user.id)
    }

    this.userLoading = false

  }

  newUser() {
    let user = new User()

    this.selectedUser = user
    this.EditUserDialog = true

  }

  cancel() {

    this.EditUserDialog = false
  }

  async onSubmitUser() {

    if (!this.validEmployeeCode) {
      return
    }
    this.userLoading = true
    const isNew = this.selectedUser?.id === null

    this.selectedUser = Object.setPrototypeOf(this.selectedUser, User.prototype)

    if (this.selectedUser) {
      try {
        let user = await this.selectedUser.save<User>()

        this.userLoading = false

        if (isNew) {
          this.users.push(user)
        }
      } catch (e) {
        this.$root.$emit('onError', {error: e})
      }
    }
    this.selectedUser = null
    this.EditUserDialog = false
  }

  toggleTheme() {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark
  }


  async mounted() {
    this.drawer_width = Math.max(80, Math.round(window.innerWidth * this.drawer_ratio))
    console.log('window.innerWidth', window.innerWidth)

    const url = Helper.setting.user.getListAPI

    try {
      this.users = await Helper.get(url).then<{ data: DataArray }>(({data}) => data.data)
    } catch (e) {
      alert(e)
    }
  }

  validEmployeeCode = true
  get requiredIfSales() {
    return [
      (v) => {
        if (this.selectedUser && this.selectedUser.role &&
            [
              UserConst.ROLE_USER,
              UserConst.ROLE_MANAGER,
              UserConst.ROLE_MARKETING,
              UserConst.ROLE_DIRECTOR
            ].includes(this.selectedUser.role) && !v) {
          this.validEmployeeCode = false
          return 'ต้องมีรหัสพนักงาน'
        }
        this.validEmployeeCode = true
        return true
      }
    ]
  }
}
</script>
